export const STORE_SERIES = 'STORE_SERIES';

export const STORE_NEWS = 'STORE_NEWS';

export const STORE_VOLUMES = 'STORE_VOLUMES';

export const STORE_ARTICLES = 'STORE_ARTICLES';

export const STORE_PUBLISHERS = 'STORE_PUBLISHERS';

export const STORE_STATISTICS_VOLUMES = 'STORE_STATISTICS_VOLUMES';
export const STORE_STATISTICS_ARTICLES = 'STORE_STATISTICS_ARTICLES';
export const STORE_STATISTICS_SERIES = 'STORE_STATISTICS_SERIES';
export const STORE_STATISTICS_VISITS = 'STORE_STATISTICS_VISITS';

export const STORE_ABOUT_US = 'STORE_ABOUT_US';

export const STORE_SLIDER = 'STORE_SLIDER';
